import Resizer from "./Resizer";
import { useRef, useEffect, Fragment } from "react";
import Table from "./Table";

const Info = ({ msg, coin, cur, scrolling }) => {
  const refP = useRef(null);
  const refC = useRef(null);
  const SP = Resizer(refP);
  const SC = Resizer(refC);

  return (
    <Fragment>
      <div
        className=" d-flex justify-content-around "
        style={{
          height: "40px",
          backgroundColor: "#fff",
          marginTop: "70px",
          overflow: "hidden",
          zIndex: "-1",
        }}
        ref={refP}
      >
        <p
          className={`${
            SP.width >= SC.width && SP.width >= msg.length * 8
              ? "static"
              : "dynamic"
          }`}
          style={{
            color: "black",
            textAlign: "center",
            whiteSpace: "nowrap",
            margin: "0",
            alignSelf: "center",
            zIndex: "0",
          }}
          ref={refC}
        >
          {msg}
        </p>
      </div>
      <Table coin={coin} cur={cur} scrolling={scrolling} />
    </Fragment>
  );
};

export default Info;
